import { configure } from "@37signals/lexxy"
configure({ default: { attachments: false } })
